import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import Check from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";

/**
 * Post–“Make it live” success screen (coach). Matches mobile + desktop: white body,
 * navy check badge, headline + subtitle, red Playbook CTA accents.
 */
export default function CommentUploadSuccess() {
  const theme = useTheme();
  const navigate = useNavigate();
  const mainColor = theme.palette.primary.main;
  const accentColor = theme.palette.secondary.main;

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#fff",
        width: "100%",
        px: { xs: 2.5, sm: 3, md: 4 },
        py: { xs: 6, sm: 8 },
        minHeight: { xs: "min(72vh, 640px)", md: "min(560px, 70vh)" },
      }}
    >
      <Box sx={{ width: "100%", maxWidth: 480, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            width: { xs: 62, md: 66 },
            height: { xs: 62, md: 66 },
            borderRadius: "50%",
            bgcolor: mainColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: { xs: 2, md: 3 },
            flexShrink: 0,
          }}
        >
          <Check sx={{ fontSize: { xs: 48, md: 52 }, color: "#fff" }} />
        </Box>

        <Typography
          component="h1"
          sx={{
            color: mainColor,
            fontSize: { xs: "1.35rem", sm: "1.5rem", md: "1.65rem" },
            fontWeight: 700,
            textAlign: "center",
            lineHeight: 1.35,
            letterSpacing: 0.01,
          }}
        >
          Video uploaded successfully.
        </Typography>

        {/* <Typography
          sx={{
            color: mainColor,
            fontSize: { xs: "1.05rem", sm: "1.15rem", md: "1.2rem" },
            fontWeight: 500,
            textAlign: "center",
            mt: { xs: 1.25, md: 1.5 },
            mb: { xs: 3.5, md: 4 },
            lineHeight: 1.45,
          }}
        >
          Post another Insight.
        </Typography> */}

        {/* <Button
          variant="contained"
          onClick={() => navigate("/create-qr")}
          sx={{
            bgcolor: mainColor,
            color: accentColor,
            textTransform: "none",
            fontWeight: 600,
            px: { xs: 5, md: 6 },
            py: { xs: 1.5, md: 1.75 },
            borderRadius: 999,
            fontSize: { xs: "1rem", md: "1.05rem" },
            width: "100%",
            maxWidth: { xs: 340, md: 360 },
            minHeight: { xs: 48, md: 52 },
            boxShadow: "none",
            "&:hover": {
              bgcolor: mainColor,
              opacity: 0.92,
              boxShadow: "none",
            },
          }}
        >
          Post another Insight
        </Button> */}
      </Box>
    </Box>
  );
}
